<template>
  <div class="container">
    <div class="top-buttons">
      <create-settlement-dialog @change="handleSearch">
        <el-button class="mwow-button-filled success">新建结算</el-button>
      </create-settlement-dialog>
      <el-button class="mwow-button-filled primary" @click="toStaffSalary"
        >设置员工工资</el-button
      >
      <payslip-dialog>
        <el-button class="mwow-button-filled inter">设置工资条项目</el-button>
      </payslip-dialog>
    </div>
    <common-search-form-wrapper :hiddenExpand="true" :reset="handleReset">
      <el-form size="mini" :model="searchInfo" label-width="80px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="工资名称:" prop="name">
              <el-input
                v-model="searchInfo.name"
                placeholder="请搜索"
                @change="handleSearch"
                clearable
                prefix-icon="el-icon-search"
                maxlength="120"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发薪日期:" prop="payment_date">
              <common-date-range-selector
                v-model="searchInfo.payment_date"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="handleSearch"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="确认状态:" prop="status">
              <el-radio-group
                v-model="searchInfo.status"
                @change="handleSearch"
              >
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button :label="2">未确认</el-radio-button>
                <el-radio-button :label="1">已确认</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="结算状态:" prop="task_status">
              <el-select
                v-model="searchInfo.task_status"
                multiple
                @change="handleSearch"
              >
                <el-option :value="1" label="等待结算"></el-option>
                <el-option :value="2" label="结算中"></el-option>
                <el-option :value="3" label="已结算"></el-option>
                <el-option :value="4" label="结算错误"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="工资所属月:" prop="month_date">
              <el-date-picker
                clearable
                v-model="searchInfo.month_date"
                type="monthrange"
                value-format="yyyy-MM"
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                @change="handleSearch"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <el-table
      size="mini"
      v-horizontal-scroll
      :data="tableData"
      stripe
      ref="mainTable"
      style="width: 100%"
      tooltip-effect="dark"
      @sort-change="handleSortChange"
      :default-sort="{
        order: 'descending',
        prop: 'create_time',
      }"
    >
      <el-table-column label="工资名称" prop="name">
        <template slot-scope="scope">
          <span v-if="scope.row.task_status !== 3">
            <el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
            >
              <p>正在结算中，请稍候</p>
              <span slot="reference" class="mwow-gray">{{
                scope.row.name
              }}</span>
            </el-popover>
          </span>
          <span
            v-else
            class="mwow-green"
            style="cursor: pointer"
            @click="toDetail(scope.row)"
            >{{ scope.row.name }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        label="工资所属月"
        prop="belong_month"
        width="160"
      ></el-table-column>
      <el-table-column label="结算区间" prop="date" width="160">
        <template slot-scope="scope"
          >{{ scope.row.start_date }} ~ {{ scope.row.end_date }}</template
        >
      </el-table-column>
      <el-table-column prop="status" width="100">
        <template slot="header">
          <span>确认状态</span>
          <el-popover
            placement="top"
            popper-class="followuppopover"
            trigger="hover"
            width="200"
          >
            <p>
              结算中的工资记录无法预览详情，待结算完毕后，可预览；<br />未确认的工资单可修改明细金额，确认后只可预览；
            </p>
            <i
              class="el-icon-question"
              slot="reference"
              style="
                margin: 0 0 0 8px;
                color: #bebfc0;
                font-size: 16px;
                vertical-align: text-bottom;
              "
            ></i>
          </el-popover>
        </template>
        <template slot-scope="scope">
          <span v-if="scope.row.status === 1" class="mwow-green">已确认</span>
          <span v-if="scope.row.status === 2" class="mwow-red">未确认</span>
        </template>
      </el-table-column>
      <el-table-column label="结算对象" prop="">
        <template slot-scope="scope"
          >{{ scope.row.salary_staff_list[0].name }} 共{{
            scope.row.salary_staff_list.length
          }}人</template
        >
      </el-table-column>
      <el-table-column label="结算金额" prop="amount">
        <template slot-scope="scope">
          <div v-if="scope.row.task_status === 3">￥{{ scope.row.amount }}</div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column
        label="发薪日期"
        prop="payment_date"
        width="100"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      >
      </el-table-column>
      <el-table-column label="操作人" prop="staff.name"></el-table-column>
      <el-table-column label="结算状态" prop="task_status" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.task_status == 1" class="mwow-gray"
            >等待结算</span
          >
          <span v-if="scope.row.task_status == 2" class="mwow-yellow"
            >结算中</span
          >
          <span v-if="scope.row.task_status == 3" class="mwow-green"
            >已结算</span
          >
          <span v-if="scope.row.task_status == 4" class="mwow-red"
            >结算错误
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="create_time"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      >
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>
<script>
import { getSalaryOrderListApi } from "@/api/salary";
import { dateFormat } from "@/utils/timeFormat";
import eventBus from "@/utils/bus";
import createSettlementDialog from "./createSettlementDialog.vue";
import payslipDialog from "./payslipDialog.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import { mixin } from "@/mixin/tabPageInfoMixin";
export default {
  props: ["visible"],
  mixins: [mixin],
  components: {
    createSettlementDialog,
    payslipDialog,
    commonDateRangeSelector,
    commonSearchFormWrapper,
  },
  data() {
    return {
      searchInfo: {
        name: "",
        payment_date: [],
        status: -1,
        task_status: [],
        sort_field: "create_time",
        sort_type: "desc",
        month_date: [],
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      tatistics: {},
      pickerOptions: {
        disabledDate(time) {
          const year = new Date().getFullYear(); //获取当前年份
          const month = new Date().getMonth() + 1; //获取当前月份
          const tot = new Date(year + "-" + month + "-1").getTime(); //获取当前年月转成时间戳
          return time.getTime() > tot;
        },
      },
    };
  },
  created() {
    eventBus.$on("quickly-create-salary-settlement", () => {
      this.handleSearch();
    });
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.handleSearch();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.handleSearch();
    }
  },
  beforeDestroy() {
    eventBus.$off("quickly-create-salary-settlement");
  },
  methods: {
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
        sort_type: this.searchInfo.sort_type,
        sort_field: this.searchInfo.sort_field,
      };
      if (this.searchInfo.name) {
        option.name = this.searchInfo.name;
      }
      if (
        this.searchInfo.payment_date &&
        this.searchInfo.payment_date.length > 0
      ) {
        option.payment_date = this.searchInfo.payment_date[0];
        option.payment_date_end = this.searchInfo.payment_date[1];
      }
      if (this.searchInfo.status >= 0) {
        option.status = this.searchInfo.status;
      }
      if (this.searchInfo.task_status.length > 0) {
        option.task_status_arr = this.searchInfo.task_status;
      }
      if (this.searchInfo.month_date && this.searchInfo.month_date.length > 0) {
        option.belong_month_start_date = this.searchInfo.month_date[0];
        option.belong_month_end_date = this.searchInfo.month_date[1];
      }
      getSalaryOrderListApi(option).then((res) => {
        if (res.error_code === 0) {
          res.data.list.map((item) => {
            item.create_time = dateFormat(
              "YYYY-mm-dd HH:MM",
              item.create_time * 1000
            );
          });
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.page = params.page;
        }
      });
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleReset() {
      this.searchInfo = {
        name: "",
        payment_date: [],
        status: -1,
        task_status: [],
        sort_field: "create_time",
        sort_type: "desc",
        month_date: [],
      };
      this.handleSearch();
    },
    handleSortChange(e) {
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.searchInfo.sort_field = e.prop;
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    toDetail(row) {
      this.mixinSavePageInfo("salaryTabStore");
      this.$router.push({
        name: "settlementDetail",
        query: {
          id: String(row.salary_id),
        },
      });
    },
    toStaffSalary() {
      this.$router.push({
        name: "staffSalary",
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.top-buttons {
  margin-bottom: 12px;
  .mwow-button-filled {
    margin-right: 12px;
  }
}
/deep/.el-table {
  th {
    &.is-sortable {
      .caret-wrapper {
        position: relative;
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;
        }
      }
    }
  }
}
</style>
